import React from 'react'

import ClickableCard from '../../layout/ClickableCard'
import ContentTag from '../ContentTag'
import { useI18N } from '../../../../libraries/i18n/hook'
import ZriveIcon from '../../../../assets/zrive-icon.svg?react'

type Props = {
  title: string
  category: string
  image: string
  url: string
  price: number
  startMonthYear: string
  duration: string
  description: string
}
const ExternalCourseCard: React.FC<Props> = ({ title, category, image, url, price, startMonthYear, duration, description }) => {
  const { t } = useI18N()
  const renderCourseImage = () => {
    const commonClasses = 'w-28 h-full sm:w-full sm:h-56 rounded-s-lg sm:rounded-b-none sm:rounded-t-lg'
    return (
      <div className={`${commonClasses} z-10`}>
        <div className={`${commonClasses} bg-gradient-to-t from-black/50 to-black/0 absolute z-10`} />
        <img src={image} alt={title} className={`${commonClasses} absolute object-cover`} />
      </div>
    )
  }

  const renderPrice = () => (
    <div className='inline-flex items-end pb-3'>
      <h3 className='text-black underline underline-offset-2 leading-none'>{price.toLocaleString('de-DE')}</h3>
      <b className='text-black text-sm pb-2.5 underline underline-offset-2'>€</b>
    </div>
  )

  return (
    <ClickableCard>
      <div >
        <a href={url} target='_blank' rel='noreferrer' className='flex sm:block relative h-full'>
          <div className='absolute z-20 left-3 top-3 hidden sm:inline-block'>
            <ContentTag label={startMonthYear} bgColor='deep-green' />
          </div>
          <div className='absolute z-20 right-3 top-3'>
            <ZriveIcon />
          </div>
          <div className='relative block'>
            <div className='h-full block sm:hidden'>{renderCourseImage()}</div>
          </div>
          <div className='hidden sm:block relative'>
            {renderCourseImage()}
            <div className='hidden sm:inline-block font-semibold absolute left-3 -translate-y-8 text-white z-30'>
              {duration}
            </div>
          </div>
          <div className='px-2.5 py-3 sm:p-3 w-full flex flex-col justify-between'>
            <div className='flex flex-col justify-between h-full sm:block'>
              <p className='h-12 line-clamp-2 text-black text-xs sm:text-sm font-semibold max-w-[92%]'>{title}</p>
              <div className='sm:hidden flex flex-col gap-y-2 justify-around text-2xs font-light'>
                <div>{t('course.nextPromotion')}: {startMonthYear}</div>
                <div>{duration}</div>
                <div className='translate-y-1 inline-flex items-center justify-between w-full'>
                  {renderPrice()}
                  <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
                </div>
              </div>
              <div className='hidden sm:inline-block'><p className='line-clamp-3 mt-2 sm:text-sm text-xs font-light leading-[1.1]'>{description}</p></div>
            </div>
            <div className='hidden translate-y-3 sm:inline-flex w-full self-end items-center justify-between'>
              <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
              {renderPrice()}
            </div>
          </div>
        </a>
      </div>
    </ClickableCard>
  )
}
export default ExternalCourseCard

